import { render, staticRenderFns } from "./ResetPassByForget.vue?vue&type=template&id=630311de&scoped=true"
import script from "./ResetPassByForget.vue?vue&type=script&lang=ts"
export * from "./ResetPassByForget.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630311de",
  null
  
)

export default component.exports